import { render } from "./CheckoutProjectItem.vue?vue&type=template&id=37a9b6da"
import script from "./CheckoutProjectItem.vue?vue&type=script&lang=js"
export * from "./CheckoutProjectItem.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__